import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoDisturbAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"do_disturb_alt"}/>
}
